import React from 'react';
import IndexContainer from 'containers/IndexContainer/IndexContainer';

export default function IndexPage() {
    return (
        <IndexContainer />
    )
}
